<template>
  <div class="search-modal">
    <div style="display: flex">
      <!-- close icon : on close icon click we call the api-->
      <div @click="this.$props.closeSearchModal" class="close-btn">
        <i class="material-icons pointer">close</i>
      </div>
      <!-- heading text -->
      <div class="header">Edit your search</div>
      <!-- filter icon -->
      <div class="filter-icon">
        <img
          src="../../../static/img/icons/filter_list_white.svg"
          width="18px"
        />
      </div>
    </div>
    <!-- location based search display flex => each button will have an underline and another text to be filteres -->
    <ul class="spotTypeFilterContainer">
      <li class="spotTypeFilterItem">
        <button @click="filterResults('all')">All</button>
      </li>
      <li class="separator"></li>
      <li class="spotTypeFilterItem">
        <button @click="filterResults('hotel')">Hotels & Apartments</button>
      </li>
      <li class="spotTypeFilterItem">
        <button @click="filterResults('bar')">Bars & Cafes</button>
      </li>
      <li class="spotTypeFilterItem">
        <button @click="filterResults('restaurant')">Restaurants</button>
      </li>
    </ul>
    <!-- search and checkin checkout text -->
    <div>
      <!-- searched location  -->
      <div class="search-details">
        <div class="filter-container mt-3">
          <div class="filter-location">
            <i class="material-icons">location_on</i>
            <select
              @change="
                query_location,
                  goToRoute($store.state.search_loc.query_location)
              "
              v-model="$store.state.search_loc.query_location"
              class="search-location-dropdown pointer"
            >
              <option value disabled selected hidden>
                Where are you going
              </option>
              <option value="worldwide">Worldwide</option>
              <option value="barcelona">Barcelona</option>
              <option value="berlin">Berlin</option>
              <option value="copenhagen">Copenhagen (København)</option>
              <option value="florence">Florence (Firenze)</option>
              <option value="lisbon">Lisbon (Lisboa)</option>
              <option value="london">London</option>
              <option value="angeles">Los Angeles</option>
              <option value="madrid">Madrid</option>
              <option value="milan">Milan (Milano)</option>
              <option value="newyork">New York</option>
              <option value="paris">Paris</option>
              <option value="porto">Porto</option>
              <option value="rome">Rome (Roma)</option>
              <option value="francisco">San Francisco</option>
            </select>
          </div>
        </div>

        <!-- checkin checkout time  -->
        <div>
          <!-- checkin -->
          <div></div>
          <!-- checkout -->
          <div></div>
        </div>
        <!-- how many guests -->
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log("LOCAL STROTAGE", this.$props);
  },
  data() {
    return {
      filterSpotType: "all",
      filterLocation: "Where are you going?",
    };
  },
  methods: {
    filterResults(spotType){
      
    }
  },
  props: {
    closeSearchModal: Function,
  },
};
</script>

<style lang="scss" scoped>
//imported styles
@import "../../assets/scss/homepage/searchModal.scss";
</style>



// WEBPACK FOOTER //
// searchModal.vue?7a7d2809